import * as React from 'react';

function SvgContactPhone(props) {
  return (
    <svg width="3em" height="3em" viewBox="0 0 27.999 29" {...props}>
      <path
        d="M7.517 21.21C4.167 17.739 2 14.757.887 12.093c-1.5-3.586-1.1-6.65 1.185-9.112a.942.942 0 01.492-.545.312.312 0 00.08-.05L4.416.549a1.882 1.882 0 012.658 0l3.987 4.134a2 2 0 010 2.754L9.289 9.274a2 2 0 000 2.755l7.087 7.346a1.883 1.883 0 002.658 0l1.772-1.837a1.88 1.88 0 012.658 0l3.987 4.132a2 2 0 010 2.755l-1.772 1.837a.308.308 0 00-.049.082.939.939 0 01-.526.511A6.833 6.833 0 0120.168 29c-3.504 0-7.523-2.474-12.651-7.79zm-5.48-9.633c1.049 2.51 3.131 5.361 6.366 8.715 4.811 4.986 8.66 7.41 11.766 7.41a5.615 5.615 0 004.182-1.9l-4.917-5.1a3.06 3.06 0 01-3.942-.413L8.4 12.947A3.343 3.343 0 018 8.86l-4.916-5.1C1.062 5.864.719 8.42 2.037 11.578zm23.2 13.307l1.329-1.378a.666.666 0 000-.918l-3.986-4.133a.632.632 0 00-.886 0l-1.329 1.378zM8.846 7.9l1.33-1.377a.67.67 0 000-.918L6.188 1.468a.629.629 0 00-.886 0L3.974 2.845z"
        fill="#eea804"
      />
    </svg>
  );
}

export default SvgContactPhone;
